(function ($) {
    $(function () {
        /*--------------------------------
        * アコーディオン
        --------------------------------*/
        $('.js-acc-header').on('click', function () {
            $(this).next('.js-acc-inner').slideToggle();
            $(this).toggleClass("--open");
        });
        /*--------------------------------
        * 各種スライダー
        --------------------------------*/
        $('.js-pic-slider').slick({
            autoplay: true,
            autoplaySpeed: 0,
            speed: 12000,
            cssEase: 'linear',
            swipe: false,
            pauseOnFocus: false, 
            pauseOnHover: false,
            arrows: false,
            variableWidth: true,
            responsive: [{
            breakpoint: 750,
                settings: {
                }
            }]
        });
        $('.js-voice-slider, .js-work-slider').slick({
            autoplay: false,
            autoplaySpeed: 0,
            cssEase: "linear",
            slidesToShow: 3,
            swipe: true,
            arrows: true,
            dots: false,
            // pauseOnFocus: false,
            // pauseOnHover: false,
            responsive: [{
            breakpoint: 750,
            settings: {
                slidesToShow: 1
            }
            }]
        });
        // アンカーリンクの位置修正
        if($(location).attr('href').indexOf("#") != -1) {
            const paths = $(location).attr('href').split("#");
            // 指定位置へスクロール
            scrollTo($('#' + paths[paths.length - 1]), $('.header'));
        }
        // ページ上部へ遷移
        $('.js-to-top').on('click', function(){
            $('html,body').animate({scrollTop:0}, 'fast');
            return false;
        });
        // アンカーリンククリック
        $('a[href^="#"]').on('click', function() {
            if ($(this).hasClass('js-to-top')) {
                return false;
            }
            const href = $(this).attr("href");
            const $target = $(href == "#" ? '' : href);
            // スムーススクロール
            scrollTo($target);
            return false;
        });
        // スムーススクロール
        function scrollTo($target, $header = '', speed = 400, type = 'swing') {
            let headerOffset = ('' === $header || 0 >= $header.length) ? 0 : $header.height();
            // headerの高さ調整
            let position = Math.round($target.offset().top - headerOffset);
            // animateでスムーススクロール
            $('body,html').animate({scrollTop:position}, speed, type);
        }
    });
})(jQuery);
